import React from 'react';

import { IBannerProps } from '@sravni/react-advertisement';

import { useBanners, useLoadingBanners } from '../../hooks/advertising';
import { useMaterials, useMaterialsList } from '../../hooks/news';
import { useIsItemPage } from '../../hooks/pageType';
import { BorderedBanner } from '../BorderedBanner';

type Props = Omit<IBannerProps, 'banner'> & {
  farce?: boolean;
  isLoading?: boolean;
  isTabletBordered?: boolean;
} & Partial<Pick<IBannerProps, 'banner'>>;

export const ReduxBanner: React.FC<Props> = ({ type, isLoading, farce, banner: propsBanner, ...props }) => {
  const isLoadingBanners = useLoadingBanners(type) || isLoading;
  const isItemPage = useIsItemPage();

  const materialAlias = (isItemPage ? useMaterials : useMaterialsList)()?.[0]?.alias;
  const banners = useBanners(materialAlias);

  const bannersList = propsBanner || banners?.[type];
  if (!isLoadingBanners && !bannersList && !farce) {
    return null;
  }

  return <BorderedBanner banner={bannersList} type={type} {...props} />;
};
